import React, { createContext, ReactNode, useState, useEffect } from 'react';
import{Device} from '@capacitor/device'
import { msalMobileLogin } from '../../shared/utils/mobileMSAL';
import { authType, RHYBUS_ACCESS_TOKEN } from '../../Configuration';
import { StatusBar } from '@capacitor/status-bar';


interface DeviceContextType {
  isMobile: boolean;
  isDeviceLoaded: boolean;
  isWeb:boolean;
}

const DeviceInitialValue: DeviceContextType = {
  isMobile: false,
  isDeviceLoaded: false,
  isWeb:false
};

const DeviceDetailsContext = createContext<DeviceContextType>(DeviceInitialValue);

const UserDeviceContextProvider = ({ children }: { children: ReactNode }) => {
  const [deviceInfo,setDeviceInfo]=useState(DeviceInitialValue)
useEffect(() => {
    fetchDeviceInfo();
  }, []);
   
const fetchDeviceInfo = async () => {
      const info = await Device.getInfo();
      const isWeb= info.platform === 'web'
      if(!isWeb){
       await StatusBar.setOverlaysWebView({ overlay: false });
       await StatusBar.setBackgroundColor({ color: '#0457aa' });
      }
      const ismobiledev = (info.operatingSystem === 'ios' || info.operatingSystem === 'android') ;
      if(ismobiledev){
       const token= localStorage.getItem(RHYBUS_ACCESS_TOKEN)
        if(!isWeb &&  authType.toLowerCase()=== 'msal' && (!token ||token === null || token === '')){
        await msalMobileLogin()
        }
          setDeviceInfo({isMobile:true,isDeviceLoaded:true, isWeb:isWeb})
      }else{
          setDeviceInfo({isMobile:false,isDeviceLoaded:true, isWeb:isWeb})
      }
};

  return (
    <DeviceDetailsContext.Provider value={deviceInfo}>
      {children}
    </DeviceDetailsContext.Provider>
  );
};

export {DeviceInitialValue, UserDeviceContextProvider, DeviceDetailsContext };
